import { useEffect, useState } from "react";
import { Banknote, ShieldCheck } from "lucide-react";
import api from "../../lib/api";
import { PageHeader } from "../../components/dashboard/Shared";

export default function Withdraw() {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    api.get("/investor/withdrawal-instructions").then(({ data }) => setInfo(data)).catch(() => {});
  }, []);

  if (!info) return <div className="skeleton h-80" />;

  return (
    <div className="max-w-2xl">
      <PageHeader title="Withdrawals" sub="Your money, your broker, your control" />
      <div className="card-dark p-6 mb-5 flex gap-4" data-testid="withdrawal-notice">
        <ShieldCheck size={24} className="text-[#00E676] shrink-0" strokeWidth={1.5} />
        <p className="text-sm text-gray-300 leading-relaxed">{info.notice}</p>
      </div>
      <div className="card-dark p-6">
        <p className="label-xs mb-5 flex items-center gap-2"><Banknote size={14} /> How to withdraw {info.broker ? `from ${info.broker}` : "from your broker"}</p>
        <ol className="space-y-4">
          {info.steps.map((s, i) => (
            <li key={i} className="flex gap-4 text-sm text-gray-300">
              <span className="tabular text-[#00F0FF] shrink-0 w-6 h-6 rounded-full border border-[#00F0FF]/30 flex items-center justify-center text-xs">{i + 1}</span>
              <span className="leading-relaxed">{s}</span>
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
}
